import {RoomAudioRenderer, useConnectionState} from '@livekit/components-react'
import {ConnectionState} from 'livekit-client'
import {RoomContent} from './RoomContent'
import {RoomHeader} from './RoomHeader'
import {RoomLoadingState} from './RoomLoadingState'

interface ConnectedRoomGuardProps {
  roomId: string
  onLeave: () => void
  focusHintOpen?: boolean
  onFocusHintOpenChange?: (open: boolean) => void
  onRequestFocusHint?: () => void
}

/**
 * Renders loading state until LiveKit WebSocket is connected,
 * then shows full room UI (header, content, audio renderer).
 * Must be used inside LiveKitRoom provider.
 */
export function ConnectedRoomGuard({
  roomId,
  onLeave,
  focusHintOpen,
  onFocusHintOpenChange,
  onRequestFocusHint,
}: ConnectedRoomGuardProps) {
  const connectionState = useConnectionState()

  if (connectionState !== ConnectionState.Connected) {
    return <RoomLoadingState />
  }

  return (
    <>
      <RoomHeader
        roomId={roomId}
        onLeave={onLeave}
        inCall={true}
        focusHintOpen={focusHintOpen}
        onFocusHintOpenChange={onFocusHintOpenChange}
        showRecordingIndicator={true}
      />
      <RoomContent roomId={roomId} onRequestFocusHint={onRequestFocusHint} />
      <RoomAudioRenderer />
    </>
  )
}
